
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
:host{padding-bottom:2rem}.header-wrapper{align-items:end;position:static}tufts-container[background-color=white]{--tufts-container-position:static;--tufts-container-wrapper-padding-bottom:0px}`;